import {api} from './connection.mjs'
import {getJsonFromElement} from './utils.js';
console.log(getJsonFromElement)

document.addEventListener('DOMContentLoaded', () => {
    const responsesList = document.getElementById('responsesList');
    const createButton = document.getElementById('createButton');
    const addResponse = async () => {
        const div = document.createElement('div');
        div.classList.add("input-group");
        const span = document.createElement('span');
        const input = document.createElement('input');
        const button = document.createElement('button');
        span.textContent = `Answer`;
        span.classList.add("input-group-text");
        span.id = "basic-addon3";
        span.style = "background-color: #c6ddfa";
        div.appendChild(span);
        input.classList.add("form-control");
        input.classList.add("item");
        input.title = "title";
        input.type = "text";
        div.appendChild(input);
        button.type = "button";
        button.classList.add("btn");
        button.classList.add("btn-outline-success");
        button.style = "background-color: #c6ddfa";
        button.textContent = ` + `;
        div.appendChild(button);
        responsesList.appendChild(div);
        button.addEventListener('click', (evt) => {
            addResponse();
        });
    }
    const createSurvey = async() => {
        const paramsList = document.getElementById("paramsList");
        const outjson = getJsonFromElement(paramsList);
        console.log(outjson);
        try{
            const response = await api("/surveys/create", outjson);
            console.log(response);

        }catch(err){
            console.error(err)
            document.querySelector("#debug").innerHTML = err.toString()
        }
    }
    createButton.addEventListener('click', (evt) => {
        createSurvey();
    });
    addResponse();
});
